/* eslint-disable no-redeclare */
import type { AdminLog } from '@studio/types';

function adminLog(...args: Parameters<typeof console.log>): void;
function adminLog(content: AdminLog.TableContent, options: AdminLog.TableOptions): void;
function adminLog(...args: Parameters<typeof console.log> | [AdminLog.TableContent, AdminLog.TableOptions]): void {
  // Check if last argument is options object
  const lastArg = args[args.length - 1];
  const isOptionsObject =
    lastArg &&
    typeof lastArg === 'object' &&
    !Array.isArray(lastArg) &&
    ('method' in lastArg || 'areAdminLogsEnabled' in lastArg || 'isResiAdmin' in lastArg);

  if (isOptionsObject && 'method' in lastArg && lastArg.method === 'table') {
    // Table case: first arg is content, second is options
    const [content, options] = args as [AdminLog.TableContent, AdminLog.TableOptions];
    const { areAdminLogsEnabled = false, isResiAdmin = false } = options;

    if (!areAdminLogsEnabled || !isResiAdmin) {
      return;
    }

    console.table(content);
  } else {
    // Non-table case: all args are console args
    const options = (isOptionsObject ? lastArg : {}) as AdminLog.Options;
    const consoleArgs = isOptionsObject ? args.slice(0, -1) : args;
    const { areAdminLogsEnabled = false, isResiAdmin = false, method = 'debug' } = options;

    if (!areAdminLogsEnabled || !isResiAdmin) {
      return;
    }

    console[method](...consoleArgs);
  }
}

export default adminLog;
